import { render, staticRenderFns } from "./IconFileText.vue?vue&type=template&id=5322077c&"
import script from "./IconFileText.vue?vue&type=script&lang=ts&"
export * from "./IconFileText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports